import axios from "axios";
import { getClientData } from "../components/custom";
import isEqual from "lodash/isEqual";
import { logout } from "./authService";
import { fetchUserIfNeeded } from "./userService";

const baseApi = process.env.REACT_APP_API_BASE_URL;
const api = axios.create({
    baseURL: baseApi,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Flag to prevent multiple simultaneous 401 handling
let isHandling401 = false;

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    async (response) => {
        if (!response.config.skipUserCheck) {
            await fetchUserIfNeeded();
        }
        return response;
    },
    async (error) => {
        console.error("API error:", error);

        // Handle 401 errors
        // if (error.response?.status === 401 && !isHandling401) {
        //     isHandling401 = true;
        //     await handle401Error();
        // }

        isHandling401 = false;
        return Promise.reject(error);
    }
);

// Centralized 401 error handling function
async function handle401Error() {
    try {
        localStorage.removeItem("token");
        localStorage.removeItem("user_data");
        // Ensure redirect only happens once
        if (window.location.pathname !== "/login") {
            window.location.href = "/login";
        }
    } catch (err) {
        console.error("Error during 401 handling:", err);
    }
}

export default api;